import { useParams } from "react-router";
import { ResultOf } from "gql.tada";
import cx from "classnames";
import { useGlobalContext } from "@utils/GlobalContext";
import { EventChapterFragment } from "@queries/fragments/EventChapterFragment";
import { Button } from "@components/shared/core/Button";
import { Link } from "@components/shared/core/Link";
import SimpleCarousel from "@components/shared/SimpleCarousel";
import { AccessibleMedia } from "@components/entries/AccessibleMedia";
import { Analytics } from "@utils/Analytics";

export const EventChapterItem = ({
  item,
  customTheme,
}: {
  item: ResultOf<typeof EventChapterFragment>;
  customTheme: boolean;
}) => {
  const { locale } = useGlobalContext();
  const { slug } = useParams();

  const handleCtaClick = () => {
    Analytics.trackEvent(`${slug}_${locale}_cta_click`);
  };

  return (
    <div className={cx('flex mt-[40px] gap-[10px] w-full dsk:flex-row flex-col', !customTheme && 'items-start')}>
      <div className={cx('flex p-[32px] pr-[60px] bg-neutral-light/15 rounded-xl relative dsk:max-w-[448px] w-full dsk:min-h-[448px]', customTheme && 'flex-col items-start justify-between bg-palette-current-true dsk:min-h-px')}>
        <div>
          <h3 className="text-palette-current-highlight font-['Netflix_Sans_Title'] font-medium text-[64px] leading-[0.94] tracking-[-0.02em] shrink-0 mb-[26px]">
            {item?.title}
          </h3>
          <p className={cx('text-body-regular text-brand-cream', customTheme && 'text-palette-current-highlight')}>{item?.body}</p>
          {item?.source &&
            <p className="font-light">{item.source.text}</p>
          }
        </div>
        {item?.chapterCta &&
          <Button
            asChild
            variant={customTheme ? 'red-mx' : 'light-on-blur'}
            size="large"
            style={{ marginTop: 30 }}
          >
            <Link link={item.chapterCta} onClick={handleCtaClick}>{item.chapterCta?.text}</Link>
          </Button>
        }
      </div>
      <div className={cx('dsk:w-[912px] w-full overflow-hidden', customTheme && 'max-h-[458px]')}>
        {item?.carouselMediaCollection?.items &&
          <SimpleCarousel
            slides={item.carouselMediaCollection.items.map((item: any) => {
              return <AccessibleMedia item={item} />
            })}
          />
        }
      </div>
    </div>
    );
};
